import React from "react";
import { Page, Navbar, Block } from "framework7-react";

const AboutPage = () => {
    return (
        <Page>
            <Navbar title="About" backLink="Back" />
            <Block>
                <p>This is the About Page.</p>
            </Block>
        </Page>
    );
};

export default AboutPage;
